<template>
    <div class="progress-bar-container">
        <div class="progress-bar">
            <div 
                class="progress" 
                :style="{ width: percentage + '%', backgroundColor: isPausedComputed ? '#AAB2CF' : '#1CCA85' }"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ui-progress-bar',

        props: {
            current: {
                type: Number,
                required: true
            },
            total: {
                type: Number,
                required: true
            },
            isPausedComputed: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            percentage() {
                if (!this.total || this.total === 0) return 0
                return Math.round((this.current / this.total) * 100)
            }
        }
        
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>